import RoadIcon from './component'

export default RoadIcon
